import { render, staticRenderFns } from "./DisplayCategoryDetail.vue?vue&type=template&id=12eb3c76&scoped=true&"
import script from "./DisplayCategoryDetail.vue?vue&type=script&lang=ts&"
export * from "./DisplayCategoryDetail.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayCategoryDetail.vue?vue&type=style&index=0&id=12eb3c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb3c76",
  null
  
)

export default component.exports